import { render, staticRenderFns } from "./CompanyDetailsFullService.vue?vue&type=template&id=630c8983&scoped=true&"
import script from "./CompanyDetailsFullService.vue?vue&type=script&lang=js&"
export * from "./CompanyDetailsFullService.vue?vue&type=script&lang=js&"
import style0 from "./CompanyDetailsFullService.vue?vue&type=style&index=0&id=630c8983&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "630c8983",
  null
  
)

export default component.exports